import type { KeyValue } from 'app/developer-v3/components/KeyValueEditor';

const convertParamsToItems = (
  params: Record<string, string>
): Array<KeyValue> =>
  Object.keys(params).map(key => ({ key, value: params[key] }));

const convertItemsToParams = (items: Array<KeyValue>): Record<string, string> =>
  items.reduce((params, item) => ({ ...params, [item.key]: item.value }), {});

export { convertItemsToParams, convertParamsToItems };
